import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { RecipeDto } from './recipe.dto';
import { StockDto } from './stock.dto';

export class StockLocationDto extends BaseDto {
    merchantId: number;
    name: string;
    code: string;
    sequence: number;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?:number;
    stocks: StockDto[];
    recipes: RecipeDto[];
    //variable to know how many stocks are assigned to it
    stocksCount: number;
    recipesCount: number;
    // just using the relation to request less information
    stockStockLocations: any[];
    recipeStockLocations: any[];
    merchant?: MerchantDto;
    active?: boolean;
}